import { baseApi } from "@/services/api/baseApi";

export const usersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /** Assignee picker and filter panels. */
    getUsers: builder.query({
      query: () => "/users",
      transformResponse: (response) => response ?? [],
      providesTags: [{ type: "Users", id: "LIST" }],
      // The team changes rarely, so keep the list for five minutes after the last
      // subscriber leaves rather than re-fetching on every queue switch.
      keepUnusedDataFor: 300,
    }),

    getUserSettings: builder.query({
      query: (guid) => `/users/${guid}/settings`,
      providesTags: (result, error, arg) => [{ type: "UserSettings", id: arg }],
    }),

    updateNotificationSettings: builder.mutation({
      query: ({ guid, data }) => ({
        url: `/users/${guid}/settings`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, arg) => [{ type: "UserSettings", id: arg.guid }],
    }),
  }),
});

export const {
  useGetUsersQuery,
  useGetUserSettingsQuery,
  useUpdateNotificationSettingsMutation,
} = usersApi;
